<script setup lang="ts">
import Icon from '~/components/Icon/Legacy/index.vue'

interface Props {
  href: string
}

interface Emits {
  (e: 'close'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()
</script>

<template>
  <NuxtLink :to="href" :class="$style.link" @click="emit('close')">
    Read More
    <Icon name="arrow-thin" />
  </NuxtLink>
</template>

<style lang="scss" module>
.link {
  --at-apply: text-bluish-darker hover:text-black;
  min-width: 100px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'Circular Std Bold';
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.48px;
  font-feature-settings: 'ss02' on, 'ss01' on,'salt' on;

  @media screen and (max-width: 768px) {
    min-width: unset;
  }

  svg {
    --at-apply: fill-bluish-darker;
    width: 11px;
    height: 11px;
    transform: rotate(-90deg);
    transition: transform 0.125s;
  }

  &:hover {
    svg {
      transform: rotate(-90deg) translateY(2px);
    }
  }
}
</style>
